import { render, staticRenderFns } from "./allocate.vue?vue&type=template&id=011a0714&"
import script from "./allocate.vue?vue&type=script&lang=js&"
export * from "./allocate.vue?vue&type=script&lang=js&"
import style0 from "./allocate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports